import request from '@/http/http'
const PREFIX = '/api/deer/companies';

//获取分销商-无权限验证
export function getCompaniesSearch(query) {
  return request({
    url: PREFIX + '/search',
    params: query
  })
}

//获取分销商列表
export function getCompanies(query) {
  return request({
    url: PREFIX,
    params: query
  })
}

//删除分销商
export function deleteCompanie(id) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id
  })
}

//批量删除分销商
export function deleteCompanies(ids) {
  return request({
    method: "delete",
    url: PREFIX + '?ids=' + ids
  })
}

//创建分销商
export function addCompanie(formData) {
  return request({
    method: "post",
    url: PREFIX,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

//更新分销商
export function updateCompanie(id, formData) {
  return request({
    method: "put",
    url: PREFIX + '/' + id,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

//通过分销商标识获取详细信息
export function getCompanieDetail(id) {
  return request({
    method: "get",
    url: PREFIX + '/' + id
  })
}

//根据分销商标识获取分销商股东信息
export function getPartners(id) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/partners'
  })
}

// 添加股东
export function addPartners(id, data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/add-partner',
    data
  })
}

// 编辑股东
export function updatePartners(id, data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/update-partner',
    data
  })
}

// 移除股东
export function removePartners(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/remove-partner',
    data
  })
}

// 更新分销商状态
export function updateStatus(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/update-status',
    data
  })
}

// 大事记-------------------------------------------------------------
// 根据条件获取分销商大事件记录
export function eventRecords(params) {
  return request({
    method: "get",
    url: PREFIX + '/event-records',
    params
  })
}
// 添加分销商大事件记录
export function addEventRecord(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/add-event-record',
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
// 更新分销商大事件记录
export function updateEventRecord(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/update-event-record',
    data
  })
}
//上传分销商大事件记录资料附件
export function uploadEventRecordMaterials(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/upload-event-record-materials',
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
// 删除大事件记录
export function deleteEventRecord(id,params) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id + '/delete-event-record',
    params
  })
}
// 删除大事件记录附件
export function deleteEventRecordMaterials(id,params) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id + '/delete-event-record-materials',
    params
  })
}
// 下载大事件记录附件
export function downloadEventRecordMaterial(id,params) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/download-event-record-material',
    params,
    responseType: 'blob'
  })
}



//电子档案--------------------------------------------------------------
//根据分销商标识获取分销商电子档案信息
export function getMaterials(id,params) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/materials',
    params
  })
}
//上传电子档案
export function uploadMaterials(id,data) {
  return request({
    method: "put",
    url: PREFIX + '/' + id + '/upload-materials',
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data
  })
}
//下载电子档案
export function downloadMaterials(id,params) {
  return request({
    method: "get",
    url: PREFIX + '/' + id + '/download-materials',
    params,
    responseType: 'blob'
  })
}
//删除电子档案
export function deleteMaterials(id,params) {
  return request({
    method: "delete",
    url: PREFIX + '/' + id + '/delete-materials',
    params
  })
}

//导出
export function exportCompaniesExport(query) {
  return request({
      url: PREFIX + '/export',
      responseType: 'blob',
      params:query
  })
}